import { render, staticRenderFns } from "./DcSelect.vue?vue&type=template&id=d4f8458a"
import script from "./DcSelect.vue?vue&type=script&lang=js"
export * from "./DcSelect.vue?vue&type=script&lang=js"
import style0 from "./DcSelect.vue?vue&type=style&index=0&id=d4f8458a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports